module.exports = __webpack_public_path__ + "static/img/background.31afee6.jpeg";